import { RequestFactory } from '../../api/RequestFactory';
import { patchApiUrl } from '../../api/config';

const mavRequest = new RequestFactory(`${patchApiUrl}/seias/rest/seocc/virus/1.0`);

export { mavRequest }



// WEBPACK FOOTER //
// ./src/actions/mav/requestFactory.ts